// extracted by mini-css-extract-plugin
export default {"list":"_2DsYL6q94rO9s0SyoCTKeI","item":"r0Gx6bLGBqpDEU1BbnMU8"};